<download-button [class]="'float-right'" toolTip="download request details"
    (click)="exportDisabledServiceAccountDetailsToCsv()">
</download-button>
<generic-search-results [showHeader]="false" [showCounter]="false" title="" [records]="userDetails"
    [displayedColumns]="userDetailsDisplayColumns" [selectableRecords]="false" [allowLocalFilter]="false"
    [sortable]="true" [defaultSortColumn]="defaultSortColumn"></generic-search-results>